
export class TabObject {

    public static readonly GENERAL_TAB = new TabObject('GENERAL');
    public static readonly PRODUCT_TAB = new TabObject('PRODUCT');
    public static readonly SERVICE_TAB = new TabObject('SERVICE');
    public static readonly STATES_TAB = new TabObject('STATES');
    public static readonly PROCESSES_TAB = new TabObject('PROCESSES');
    public static readonly SITES_TAB = new TabObject('SITES');
    public static readonly BILLING_TAB = new TabObject('BILLING');
    public static readonly DEPENDENCIES_TAB = new TabObject('DEPENDENCIES');
    public static readonly NOTIFICATIONS_TAB = new TabObject('NOTIFICATIONS');
    public static readonly RESOURCE_TAB = new TabObject('RESOURCE');


    private constructor(public name: string) {
    }

    public static createWithName(name: string): TabObject {
        switch (name) {
            case this.GENERAL_TAB.name: return this.GENERAL_TAB;
            case this.PRODUCT_TAB.name: return this.PRODUCT_TAB;
            case this.SERVICE_TAB.name: return this.SERVICE_TAB;
            case this.STATES_TAB.name: return this.STATES_TAB;
            case this.PROCESSES_TAB.name: return this.PROCESSES_TAB;
            case this.SITES_TAB.name: return this.SITES_TAB;
            case this.BILLING_TAB.name: return this.BILLING_TAB;
            case this.DEPENDENCIES_TAB.name: return this.DEPENDENCIES_TAB;
            case this.NOTIFICATIONS_TAB.name: return this.NOTIFICATIONS_TAB;
            case this.RESOURCE_TAB.name: return this.RESOURCE_TAB;
            default: return this.GENERAL_TAB
        }
    }

    public equals(tab: TabObject): boolean {
        return this.name === tab.name;
    }

}
